module.exports = __webpack_public_path__ + "img/control_de_calidad_4-3_2048.26bf5a5c.jpg";